import { forwardRef, JSX, useEffect, useImperativeHandle, useRef } from "react"
import './ContextMenu.css'

export interface ContextMenuProps {
    isOpen: boolean
    position: { x: number; y: number }
    setIsOpen: (isOpen: boolean) => void
    items: JSX.Element[]
    onClose?: () => void
}

export const ContextMenu = forwardRef<HTMLDivElement, ContextMenuProps>(({ isOpen, position, setIsOpen, items, onClose }, forwardedRef) => {
    const menuRef = useRef<HTMLDivElement>(null)
    useImperativeHandle(forwardedRef, () => menuRef.current as HTMLDivElement)

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                onClose?.()
            }
        }

        document.addEventListener('click', handleClickOutside)

        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [onClose])

    const menuStyle: React.CSSProperties = {
        position: 'fixed',
        left: `${position.x}px`,
        top: `${position.y}px`,
        zIndex: 1000,
        display: position.x === 0 && position.y === 0 ? 'none' : 'block'

    }

    return (
        <div ref={menuRef} className="context-menu-wrapper" style={menuStyle}>
            <div className="context-menu">
                {items.map((item, index) => (
                    <div
                        key={index}
                        className="context-menu-item"
                    >
                        {item}
                    </div>
                ))}
            </div>
        </div>
    )
})